exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".status[data-v-7a7b62b5] {\n  color: #fff !important;\n  min-width: 140px;\n  text-align: center;\n  display: block;\n  line-height: 31px;\n  font-weight: 400;\n  max-width: 140px;\n  cursor: pointer;\n}\n[data-v-7a7b62b5] .dropdown-menu li {\n  cursor: pointer !important;\n}\n.bulk-status[data-v-7a7b62b5] {\n  width: 100%;\n  min-width: initial;\n  max-width: 100%;\n  background-color: #00bcd4;\n}\n", ""]);

// exports
